<p-table [value]="allOrderSource" dataKey="id">
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Type</th>
        <th>Is Active</th>
        <th>Action</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-source>
      <tr>
        <td>{{source.name}}</td>
        <td>{{source.type?source.type.name:''}}</td>
        <td>{{source.statusId==statusConstants.ACTIVE?answertypeConstants.Yes:answertypeConstants.No}}</td>
        <td class="action">
          <span class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top"><i class="pi
            pi-pencil" (click)="showEditOrderSource(source)"></i></span>
          <span class="btnBars p-mr-0" pTooltip="Delete" (click)="deleteOrderSource(source)"
            tooltipPosition="top"><i class="pi pi-trash"></i></span>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog header="{{addEditOrderSourceHeader}}" [(visible)]="displayOrderSourceAdd" [modal]="true" [responsive]="true"
  [style]="{width: '60vw'}">
  <form [formGroup]="orderSourceForm">
    <div class="header">
        <h5>Order Source Information
          <p-inputSwitch class="header-switch"formControlName="statusId"></p-inputSwitch>
        </h5>
      </div>
      <div class="card">
        <div class="p-field p-formgrid p-grid">
          <div class="p-col-12 p-md-6">
            <label>Name <span style="color: red;">*</span></label>
            <input pInputText type="text" formControlName="name"/>
            <small *ngIf="invalidData" class="p-invalid">Name already exists.</small>
          </div>
          <div class="p-col-12 p-md-6">
            <label>Type</label>
            <p-dropdown [options]="sourceTypes" formControlName="typeId" optionLabel="name" 
              placeholder="Select Type" [ngModelOptions]="{standalone: true}" appendTo="body"></p-dropdown>
          </div>
        </div>
      </div>
  </form>
  <p-footer>
    <button type="button" pButton (click)="displayOrderSourceAdd=false" label="Cancel" class="p-button-secondary"></button>
    <button type="button" pButton [disabled]="!orderSourceForm.valid" 
    (click)="saveOrderSource(orderSourceForm.value)" label="Save"></button>
  </p-footer>
</p-dialog>